export default function Navigation() {
  return (
    <section className="flex justify-between items-center px-6 py-10">
      
      {/* Left side */}
      <div className="flex items-center">
        <img
          src="/images/harveykwiyaniheader.png"
          alt="Harvey Kwiyani"
          className="w-8 h-8 rounded-full object-cover mr-2"
        />

        <h4 className="leading-tight font-bold">
          Harvey Kwiyani
        </h4>

        <div className="ml-1 w-2 h-2 bg-[#3B5E4C] rounded-full"></div>
      </div>

      {/* Right side */}
      <div className="flex items-center md:gap-6 gap-3">
        
        <a href="#about" className="cursor-pointer hover:text-[#D07728] transition text-sm md:text-base">
          About
        </a>
        <a href="#blog" className="cursor-pointer hover:text-[#D07728] transition text-sm md:text-base">
          Blog
        </a>
        <a href="#contact" className="cursor-pointer hover:text-[#D07728] transition text-sm md:text-base">
          Contact
        </a>
      </div>

    </section>
  );
}